import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {FueltaxService} from '../../service/fueltax/fueltaxService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {attachWorkspaceFilterState} from '../../utils/workspaceStateUtil.js';


/* global customElements */
class IftaRatesGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var iftaRateGrid = this;
		setTimeout(function(){
			iftaRateGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var iftaRateGrid = this;
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [								
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterYear',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 200px;',
					label: 'Year',
					'item-value-path': 'code',
					'item-label-path': 'description',								
					postinit: function(combo) {						
						var lookups = [];
						
						var startYear = (new Date()).getFullYear()-5;
						var endYear = (new Date()).getFullYear() + 1;
						for (var i=startYear; i<=endYear; i++) {
							lookups.push({
								code: i,
								description: i	
							});
						}						
						
						combo.items = lookups;						
					},
					placeHolder: 'Select',
					listeners: {
						'selected-item-changed': {
							fn: function() {
								if (actionRefresh) {
									actionRefresh();
								}
							},
							buffer: 2000
						}
					}
				},
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterQuarter',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 200px;',
					label: 'Quarter',
					'item-value-path': 'code',
					'item-label-path': 'description',									
					postinit: function(combo) {						
						var lookups = [
							{
								code: 0,
								description: '1 Jan 1 - March 31'
							},
							{
								code: 1,
								description: '2 April 1 - June 30'
							},
							{
								code: 2,
								description: '3 July 1 - Sept 30'
							},
							{
								code: 3,
								description: '4 Oct 1 - Dec 31'
							}
						];								
						
						combo.items = lookups;						
					},
					placeHolder: 'Select',
					listeners: {
						'selected-item-changed': {
							fn: function() {
								if (actionRefresh) {
									actionRefresh();
								}
							},
							buffer: 2000
						}
					}
				}
			]
		});		
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['ADMIN_IFTA_TAX_RATES:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_IFTA_TAX_RATES:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'detail',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_IFTA_TAX_RATES:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:list', ' Details')						
					],
					listeners: {
						click: function() {
							actionManageDetails(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',
							itemid: 'upload',
							'class': 'spacer-toolbar-item',					
							permissions: ['ADMIN_IFTA_TAX_RATES:WRITE'],						
							children:[
								ElementUtil.makeIcon('vaadin:upload', 'Import')						
							],
							listeners: {
								click: function() {
									actionUpload();
								}
							}							
						},											
						{
							tag: 'span',
							innerHTML: '|'
						},
						{
							tag: 'dl-action-button',
							itemid: 'delete',
							theme: 'error primary',					
							permissions: ['ADMIN_IFTA_TAX_RATES:DELETE'],
							'class': 'spacer-toolbar-item',								
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems);
								}
							}
						}
					]
				}											
			]
		});		
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});			
	
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-select': true,
					'auto-width': true,
					listeners: {
						'select-all-changed': function() {
							gridSelectionChange();
						}
					}					
				},				
				{						
					tag: 'vaadin-grid-column',
					path: 'startDate',
					header: 'Start Date',					
					width: '7em'
				},
				{		
					tag: 'vaadin-grid-column',
					path: 'endDate',
					header: 'End Date',
					width: '7em'
				},
				{						
					path: 'usExchangeRate',
					header: 'US Exchange Rate',			
					width: '7em'
				},
				{						
					path: 'canExchangeRate',
					header: 'Can Exchange Rate',
					width: '9em'
				},
				{						
					path: 'estimatedFinalChartInd',
					header: 'Estimated / Final',			
					width: '7em'
				},
				{						
					path: 'updateUser',
					header: 'Update User',
					width: '7em'
				},
				{						
					path: 'updateDts',
					header: 'Update Dts',				
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
			
		var gridSelectionChange = function() {
			setTimeout(function(){
				if (grid.selectedItems.length > 1) {					  					
					ElementUtil.query(toolbar, 'edit').disabled = true;						
					ElementUtil.query(toolbar, 'detail').disabled = true;	
					ElementUtil.query(toolbar, 'delete').disabled = false;
				} else if (grid.selectedItems.length === 1) {					
					ElementUtil.query(toolbar, 'edit').disabled = false;				
					ElementUtil.query(toolbar, 'detail').disabled = false;
					ElementUtil.query(toolbar, 'delete').disabled = false;
				}else {						
					ElementUtil.query(toolbar, 'edit').disabled = true;
					ElementUtil.query(toolbar, 'detail').disabled = true;	
					ElementUtil.query(toolbar, 'delete').disabled = true;
				}
			});
		};	
			
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
												
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'periodStartDate',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',							
							year: ElementUtil.query(toolbarFilter, 'filterYear').value,
							quarter: ElementUtil.query(toolbarFilter, 'filterQuarter').value
						};
						
						if (iftaRateGrid.admin) {
							var selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
							if (selectedCompany) {
								grid.currentFilter.companyId = selectedCompany;
							}							
						}
												
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;						
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();						
						};
						
						FueltaxService.getIftaService().getIftaTaxRates(grid.currentFilter).then(function(records){
							successHandler(records);
						});						
					};	
					
					loadData();
														
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'ifta-rates',
			showDetail: false
		});
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footer.footerContainer
			]
		});		
		iftaRateGrid.append(flexLayout);		
			
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};
		attachWorkspaceFilterState(iftaRateGrid, toolbarFilter, ['filterYear','filterQuarter'], actionRefresh);
				
		var actionAddEdit = function(record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit Tax Header' : 'Add Tax Header',
				icon: 'vaadin:edit',				
				width: 800,
				height: 375,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-combo-box',
											label: 'Year',
											'item-value-path': 'code',
											'item-label-path': 'description',
											name: 'taxYear',											
											postinit: function(combo) {	
												var lookups = [];

												var startYear = (new Date()).getFullYear() - 5;
												var endYear = (new Date()).getFullYear() + 1;
												for (var i = startYear; i <= endYear; i++) {
													lookups.push({
														code: i,
														description: i
													});
												}

												combo.items = lookups;
												combo.required = true;
											},
											placeHolder: 'Select'
										},
										{
											tag: 'vaadin-combo-box',
											itemId: 'month',
											label: 'Month',
											'item-value-path': 'code',
											'item-label-path': 'description',
											name: 'taxMonth',											
											postinit: function(combo) {	
												var lookups = [
													{code: 0, description: 'January'},
													{code: 1, description: 'February'},
													{code: 2, description: 'March'},
													{code: 3, description: 'April'},
													{code: 4, description: 'May'},
													{code: 5, description: 'June'},
													{code: 6, description: 'July'},
													{code: 7, description: 'August'},
													{code: 8, description: 'September'},
													{code: 9, description: 'October'},
													{code: 10, description: 'November'},
													{code: 11, description: 'December'}													
												];
												combo.items = lookups;												
												combo.required = true;
											},
											placeHolder: 'Select'
										},
										{
											tag: 'vaadin-number-field',
											name: 'usExchangeRate',
											required: true,
											label: 'US Exchange Rate'
										},
										{
											tag: 'vaadin-number-field',
											name: 'canExchangeRate',
											required: true,
											label: 'CAN Exchange Rate'
										},
										{
											tag: 'vaadin-combo-box',
											label: 'Estimated / Final',
											'item-value-path': 'code',
											'item-label-path': 'description',
											name: 'estimatedFinalChartInd',										
											value: 'E',
											postinit: function(combo) {	
												Service.getLookupService().getLookupValues('TaxEstimatedFinalCode').then(function(data){
													combo.items = data;
													combo.required = true;
												});
											},
											placeHolder: 'Select'
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																												
															formPanel.submitForm({
																preSubmit: function(data) {		
																	
																	return data;
																},
																actualCall: function(data) {
																	if (record) {
																		data.iftaTaxId = record.iftaTaxId;
																	}																	
																	return FueltaxService.getIftaService().saveIftaRates(data, (record ? true : false));
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Ifta Rate Period', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});															
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);
						
						if (record) {	
							//var loadRecord = Object.assign({}, record);
							//loadRecord.taxMonth = '' + loadRecord.taxMonth;
							formPanel.load(record);
							
							setTimeout(function(){
								if (record.taxMonth === 0) {
									ElementUtil.query(formPanel, 'month').value = 0;
								}
								
								ElementUtil.query(formPanel, 'month').focus();
								ElementUtil.query(formPanel, 'month').blur();
							}, 50);
							
						}
					}
				}
			});			
		};
		
		var actionDelete = function(records) {
	
			var requestModel = {
				ids: []
			};			
			records.forEach(function(item){				
				requestModel.ids.push(item.iftaTaxId);
			});
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete the selected rates(s)?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							FueltaxService.getIftaService().deleteIftaRates(requestModel)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed', {									
									theme: 'success'
								});
								actionRefresh();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
	
		};	
		
		var actionUpload = function() {
			var uploadWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Import State Tax File',
				icon: 'vaadin:upload',
				width: 800,
				height: 600,
				listeners: {
					ready: function() {						
						uploadWin.show();
						
						var uploadHandler = function() {
							
							var uploadField = ElementUtil.query(uploadFormPanel, 'uploadField');
							
							if (uploadFormPanel.isValid()) {
								var proceed = true;
								var data = uploadFormPanel.getData();								
								if (data.periodType === 'M') {
									if (!data.month) {
										proceed = false;
										window.DL.MessageUtil.showOkMessage('A month is required.');
									}
								} else {
									if (!data.quarter) {
										proceed = false;
										window.DL.MessageUtil.showOkMessage('A quarter is required.');										
									}
								}
							
								if (proceed) {
									if (!uploadField.files || uploadField.files.length < 1) {
										window.DL.MessageUtil.showOkMessage('A import file is required.');
									} else {
										uploadField.uploadFiles();
									}
								}
							}
							
						};
						
						var uploadFormPanel = ElementUtil.create({
								tag: 'dl-form-panel',
								itemid: 'form',
								children: [
									{
										tag: 'vaadin-form-layout',										
										children: [												
											{
												tag: 'vaadin-combo-box',
												label: 'Year',
												'item-value-path': 'code',
												'item-label-path': 'description',
												name: 'year',
												required: true,
												postinit: function(combo) {	
													var lookups = [];

													var startYear = (new Date()).getFullYear() - 5;
													var endYear = (new Date()).getFullYear() + 1;
													for (var i = startYear; i <= endYear; i++) {
														lookups.push({
															code: i,
															description: i
														});
													}

													combo.items = lookups;
												},
												placeHolder: 'Select'
											},
											{
												tag: 'vaadin-combo-box',
												itemId: 'periodType',
												label: 'Period Type',
												'item-value-path': 'code',
												'item-label-path': 'description',
												name: 'periodType',
												value: 'quarter',
												postinit: function(combo) {	
													var lookups = [
														{
															code: 'M',
															description: 'Month'
														},
														{
															code: 'Q',
															description: 'Quarter'
														}
													];

													combo.items = lookups;
												},
												placeHolder: 'Select',
												listeners: {
													change: function(evt) {

														var monthCB = ElementUtil.query(uploadFormPanel, 'uploadMonthCB');
														var quarterCB = ElementUtil.query(uploadFormPanel, 'uploadQuarterCB');

														var newValue = ElementUtil.query(uploadFormPanel, 'periodType').value;

														if (newValue === 'M') {
															monthCB.disabled = false;
															quarterCB.disabled = true;
														} else {
															monthCB.disabled = true;
															quarterCB.disabled = false;
														}
													}
												}
											},
											{
												tag: 'vaadin-combo-box',
												itemId: 'uploadQuarterCB',
												label: 'Quarter',
												'item-value-path': 'code',
												'item-label-path': 'description',
												name: 'quarter',										
												postinit: function(combo) {	
													var lookups = [
														{code: '0', description: '1 Jan 1 - March 31'},
														{code: '1', description: '2 April 1 - June 30'},
														{code: '2',	description: '3 July 1 - Sept 30'},
														{code: '3', description: '4 Oct 1 - Dec 31'}
													];								

													combo.items = lookups;	
												},
												placeHolder: 'Select'
											},
											{
												tag: 'vaadin-combo-box',
												itemId: 'uploadMonthCB',
												label: 'Month',
												'item-value-path': 'code',
												'item-label-path': 'description',
												name: 'month',	
												disabled: true,
												postinit: function(combo) {	
													var lookups = [
															{code: '0', description: 'January'},
															{code: '1', description: 'February'},
															{code: '2', description: 'March'},
															{code: '3', description: 'April'},
															{code: '4', description: 'May'},
															{code: '5', description: 'June'},
															{code: '6', description: 'July'},
															{code: '7', description: 'August'},
															{code: '8', description: 'September'},
															{code: '9', description: 'October'},
															{code: '10', description: 'November'},
															{code: '11', description: 'December'}													
														];
													combo.items = lookups;
												},
												placeHolder: 'Select'
											},
											{
												tag: 'vaadin-number-field',
												label: 'US Exchange Rate',
												required: true,
												name: 'usExchangeRate',
												decimalPrecision: 4										
											},
											{
												tag: 'vaadin-number-field',
												label: 'Canada Exchange Rate',
												required: true,
												name: 'canExchangeRate',
												decimalPrecision: 4
											},
											{
												tag: 'vaadin-combo-box',
												label: 'Estimated / Final',
												'item-value-path': 'code',
												'item-label-path': 'description',
												name: 'estimatedFinalChartInd',												
												value: 'E',
												postinit: function (combo) {
													Service.getLookupService().getLookupValues('TaxEstimatedFinalCode').then(function (data) {
														combo.items = data;
														combo.required = true;
													});
												},
												placeHolder: 'Select'
											},
											{
												tag: 'vaadin-upload',												
												itemid: 'uploadField',
												colspan: 2,
												'no-auto':  true,
												'max-files': 1,
												required: true,
												target: '/api/resource/ifta-tax-rates/import',
												headers: ImportUtil.getUploadHeader(),
												listeners: {
													'upload-request': function(event) {
														var data = uploadFormPanel.getData();																										
														event.detail.formData.append('iftaViewJson', JSON.stringify(data));
													},
													'upload-success': function(event) {
														var responseData = JSON.parse(event.detail.xhr.responseText);
														if (responseData.uploadFile) {
															//error 
															window.DL.MessageUtil.showOkMessage(
																responseData.uploadFile + '<br>' +
																responseData.uploadFileType ? responseData.uploadFileType : ''
															);
														} else {
															window.DL.MessageUtil.showToast('Uploaded Successfully.', 'Runs in the background<br>Watch Notifications for completion.', {
																theme: 'success'
															});

															actionRefresh();
															uploadWin.close();
														}
													}
												}
											}
										]
									},
									{
										tag: 'vaadin-form-layout',										
										children: [											
											{
												tag: 'hr',
												colspan: 2
											},
											{
												tag: 'div',
												style: 'text-align: center;',
												colspan: 2,
												defaults: {
													tag: 'vaadin-button'
												},
												children: [
													{
														theme: 'primary',
														children: [
															ElementUtil.makeIcon('vaadin:upload', ' Upload')
														],
														listeners: {
															click: function() {
																if (uploadFormPanel.isValid()) {																	
																	uploadHandler();
																}
															}
														}
													},
													{
														theme: 'tertiary',
														innerHTML: 'Cancel',
														style: 'margin-left: 10px;',
														listeners: {
															click: function() {																
																uploadWin.close();
															}
														}
													}
												]
											}
										]
									}
								]
						});
						uploadWin.addToContentElement(uploadFormPanel);
						
					}
				}
				
				
			});					
			
		};
		
		var actionManageDetails = function(taxHeader) {
			var detailWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Tax Rate Details for ' + (taxHeader.taxMonth + 1) + ' - ' + taxHeader.taxYear,
				icon: 'vaadin:list',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						detailWin.show();
						
						var detailToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'dl-action-button',
									itemid: 'add',
									theme: 'primary',
									'class': 'spacer-toolbar-item',
									permissions: ['ADMIN_IFTA_INTEREST_RATES:WRITE'],
									children: [
										ElementUtil.makeIcon('vaadin:plus', ' Add')
									],
									listeners: {
										click: function () {
											actionAddEditDetail();
										}
									}
								},
								{
									tag: 'dl-action-button',
									itemid: 'edit',
									'class': 'spacer-toolbar-item',
									disabled: true,
									permissions: ['ADMIN_IFTA_INTEREST_RATES:WRITE'],
									children: [
										ElementUtil.makeIcon('vaadin:edit', ' Edit')
									],
									listeners: {
										click: function () {
											actionAddEditDetail(detailGrid.selectedItems[0]);
										}
									}
								},
								{
									tag: 'div',
									style: 'float: right;',
									children: [										
										{
											tag: 'dl-action-button',
											itemid: 'export',
											'class': 'spacer-toolbar-item',
											permissions: ['ADMIN_IFTA_INTEREST_RATES:READ'],
											children: [
												ElementUtil.makeIcon('vaadin:download', 'Export')
											],
											listeners: {
												click: function () {
													actionExport();
												}
											}
										},
										{
											tag: 'span',
											innerHTML: '|'
										},
										{
											tag: 'dl-action-button',
											itemid: 'delete',
											theme: 'error primary',
											permissions: ['ADMIN_IFTA_INTEREST_RATES:DELETE'],
											'class': 'spacer-toolbar-item',
											children: [
												ElementUtil.makeIcon('vaadin:trash', ' Delete')
											],
											listeners: {
												click: function () {
													actionDeleteDetail(detailGrid.selectedItems[0]);
												}
											}
										}
									]
								}
							]
						});
						
						var allExpanders = [];
						var detailGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true,
								listeners: {
									'direction-changed': function (event) {
										if (event.detail && event.detail.value) {
											detailGrid.currentSortField = event.target.path;
											detailGrid.currentSortDirection = event.detail.value.toUpperCase();											
										}
									}
								}
							},
							children: [
								{
									tag: 'vaadin-grid-column',
									'flex-grow': '0',
									width: '50px',					
									renderer: function(root, column, rowData) {
										var expander = ElementUtil.create({
											tag: 'span',
											'class': 'grid-expander',
											trustedInnerHTML: true,
											innerHTML: '<b>+</b>',
											properties: {
												expanded: false
											},
											listeners: {
												click: function() {
													if (expander.expanded) {
														expander.innerHTML = '<b>+</b>';
														expander.expanded = false;
														detailGrid.closeItemDetails(root.item);
													} else {
														expander.innerHTML = '<b>-</b>';
														expander.expanded = true;
														detailGrid.openItemDetails(root.item);
													}
												}
											}
										});
										allExpanders.push(expander);
										
										//this must be set for expand to open
										root.item = rowData.item;
										if (!root.firstElementChild) {
											root.append(expander);
										}
									}
								},									
								{
									path: 'stateProvCode',
									header: 'State/Prov',
									width: '7em'
								},
								{
									path: 'countryCode',
									header: 'Country',
									width: '7em'
								},
								{
									path: 'periodStartDate',
									header: 'Start Date',
									width: '7em'
								},
								{
									path: 'periodEndDate',
									header: 'End Date',
									width: '7em'
								}
							],
							listeners: {
								'active-item-changed': function (event) {
									const item = event.detail.value;
									detailGrid.selectedItems = item ? [item] : [];
									if (detailGrid.selectedItems.length > 0) {
										ElementUtil.query(detailToolbar, 'edit').disabled = false;
										ElementUtil.query(detailToolbar, 'delete').disabled = false;
									} else {
										ElementUtil.query(detailToolbar, 'edit').disabled = true;
										ElementUtil.query(detailToolbar, 'delete').disabled = true;
									}
								}
							}
						});	
						
						detailGrid.rowDetailsRenderer = function (root, grid, rowData) {
							if (!root.firstElementChild) {
																
								var detailRows = '';	
								var sortedRates = rowData.item.rates;
								sortedRates.sort(function(a,b){
									return a.fuelType.localeCompare(b.fuelType);
								});								
								
								sortedRates.forEach(function(rate){
									detailRows += `
										<tr>
											<td>${rate.fuelType}</td>
											<td>${rate.usRate}</td>
											<td>${rate.usSurchargeRate ? rate.usSurchargeRate : 0}</td>
											<td>${rate.canRate}</td>
											<td>${rate.canSurchargeRate ? rate.canSurchargeRate : 0}</td>
										<tr>	
									`;
								});								
								
								root.innerHTML = '<table class="tax-details">' +
										'<tr><td>Fuel Type</td><td>US Rate</td><td>US Surcharge</td><td>CAN Rate</td><td>CAN Surcharge</td></tr>'+	
										detailRows +
										'</table>';
							}
						};
						
						var detailFlexLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								detailToolbar,
								detailGrid, {
									tag: 'style', 
									innerHTML: `
										.tax-details {
										  font-family: Arial, Helvetica, sans-serif;
										  border-collapse: collapse;
										  width: 100%;
										}

										.tax-details td, .tax-details th {
										  border: 1px solid #ddd;
										  padding: 8px;
										}

										.tax-details tr:nth-child(even){
										  background-color: #605d5d;
										  color: white;
										}

										.tax-details tr:hover {background-color: #999;}

										.tax-details th {
										  padding-top: 12px;
										  padding-bottom: 12px;
										  text-align: left;
										  background-color: #04AA6D;
										  color: white;
										}
									`
								}
							]
						});	
						
						detailWin.addToContentElement(detailFlexLayout);							
					
						var actionDetailRefresh = function() {
							var loadMask = detailGrid.showLoading();
							FueltaxService.getIftaService().getIftaTaxDetails(taxHeader.iftaTaxId).then(function(data){
								loadMask.remove();
								
								detailGrid.activeItem = null;															
								detailGrid.items = data.details;								
								
								//reset to collapse
//								allExpanders.forEach(function(item){
//									item.innerHTML = '<b>+</b>';
//									item.expanded = false;
//								});
//								setTimeout(function(){
//									detailGrid.requestContentUpdate();
//									console.log('called timeout');
//								}, 250);
								
								
							}).catch(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToastError('Failed to load Details');
							});
						};
						actionDetailRefresh();
						
						var actionAddEditDetail = function(record) {
							
							var addEditWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: record ? 'Edit Details' : 'Add Details',
								icon: 'vaadin:edit',
								width: .85,
								height: .85,
								listeners: {
									ready: function () {
										addEditWin.show();
										
										var loadMask = addEditWin.getContentElement().showLoading();
										//fuel types
										var iftaFuelTypes = [];
										Service.getLookupService().getLookupValues('FuelType').then(function(fuelTypes) {
											var rateFields = []; 											
											loadMask.remove();
											
											fuelTypes.forEach(function(fuelType){
												if (fuelType.code !== 'OTH') {
													iftaFuelTypes.push(fuelType);
												
													var fuelTypeBlock = {
														tag: 'div',
														defaults: {
															style: 'width: 20%; margin: 0px 10px 0px 0px;'
														},
														children: [
															{
																tag: 'span',
																style: 'width: 100px; margin: 0px 10px 0px 0px; display: inline-block;',
																trustedInnerHTML: true,
																innerHTML: '<b>' + fuelType.description + '</b>'
															},
															{
																tag: 'vaadin-number-field',															
																required: true,										
																name: fuelType.code + '.usTaxRate',
																value: 0,
																decimalPrecision: 4,
																children: [
																	{
																		tag: 'div',
																		slot: 'prefix',
																		innerHTML: 'US Rate'
																	}
																]
															},
															{
																tag: 'vaadin-number-field',														
																required: true,
																name: fuelType.code + '.usSurchargeRate',
																value: 0,
																decimalPrecision: 4,
																children: [
																	{
																		tag: 'div',
																		slot: 'prefix',
																		innerHTML: 'US Surcharge'
																	}
																]
															},
															{
																tag: 'vaadin-number-field',																
																required: true,
																name: fuelType.code + '.canTaxRate',
																value: 0,
																decimalPrecision: 4,
																children: [
																	{
																		tag: 'div',
																		slot: 'prefix',
																		innerHTML: 'CAN Rate'
																	}
																]										
															},
															{
																tag: 'vaadin-number-field',																
																required: true,
																name: fuelType.code + '.canSurchargeRate',
																value: 0,
																decimalPrecision: 4,
																children: [
																	{
																		tag: 'div',
																		slot: 'prefix',
																		innerHTML: 'CAN Surcharge'
																	}
																]										
															}															
														]
													};													
													rateFields.push(fuelTypeBlock);													
												}
											});											
											
											var formPanel = ElementUtil.create({
												tag: 'dl-form-panel',
												itemid: 'form',
												children: [
													{
														tag: 'vaadin-combo-box',
														itemId: 'stateCombo',
														label: 'State / Prov',
														'item-value-path': 'code',
														'item-label-path': 'description',
														name: 'stateProvCode',
														style: 'width: 20%; margin: 0px 10px 0px 0px;',
														required: true,
														postinit: function (combo) {
															Service.getLookupService().getLookupValues('StateProvCode').then(function (data) {
																var iftaStates = [];
																//filter to ifta only
																data.forEach(function(state){
																	if (state.iftaTaxFlg) {
																		iftaStates.push(state);
																	}
																});
																
																combo.items = iftaStates;
															});
														},
														placeHolder: 'Select'
													},
													{
														tag: 'vaadin-date-picker',														
														itemId: 'startDate',
														style: 'width: 20%; margin: 0px 10px 0px 0px;',
														name: 'periodStartDate',
														label: 'Start Date',
														required: true
													},
													{
														tag: 'vaadin-date-picker',
														itemId: 'endDate',
														style: 'width: 20%; margin: 0px 10px 0px 0px;',
														name: 'periodEndDate',
														label: 'End Date',
														required: true
													},													
													rateFields,
													{													
														tag: 'vaadin-form-layout',
														children: [
															{
																tag: 'hr',
																colspan: 2
															},
															{
																tag: 'div',
																style: 'text-align: center;',
																colspan: 2,
																defaults: {
																	tag: 'vaadin-button'
																},
																children: [
																	{
																		theme: 'primary',
																		children: [
																			ElementUtil.makeIcon('vaadin:database', ' Save')
																		],
																		listeners: {
																			click: function () {

																				formPanel.submitForm({
																					preSubmit: function (data) {

																						var countryCode = ElementUtil.query(formPanel, 'stateCombo').selectedItem.country;
																						data.countryCode = countryCode;
																						data.periodStartDate = TimeUtil.formatDateOnlyFromDate(data.periodStartDate);
																						data.periodEndDate = TimeUtil.formatDateOnlyFromDate(data.periodEndDate);

																						var saveModel = {
																							stateProvCode: data.stateProvCode,
																							countryCode: data.countryCode,
																							taxYear: taxHeader.taxYear,
																							taxMonth: taxHeader.taxMonth,
																							estimated: taxHeader.estimatedFinalChartInd,
																							periodStartDate: data.periodStartDate,
																							periodEndDate: data.periodEndDate,
																							rates: []
																						};

																						// On edit, locate existing rows by the period that was loaded
																						if (record) {
																							saveModel.originalPeriodStartDate = record.periodStartDate;
																							saveModel.originalPeriodEndDate = record.periodEndDate;
																						}
																						
																						//unpack rates
																						iftaFuelTypes.forEach(function(fuelType){
																							saveModel.rates.push({
																								fuelType: fuelType.code,
																								usRate: data[fuelType.code + '.usTaxRate'],
																								usSurchargeRate: data[fuelType.code + '.usSurchargeRate'],
																								canRate: data[fuelType.code + '.canTaxRate'],
																								canSurchargeRate: data[fuelType.code + '.canSurchargeRate']
																							});
																						});																						

																						return saveModel;
																					},
																					actualCall: function (data) {
																						return FueltaxService.getIftaService().saveIftaDetails(taxHeader.iftaTaxId, data, (record ? true : false));
																					},
																					success: function (data, responseData) {
																						window.DL.MessageUtil.showToast('Success', 'Saved Ifta Details', {
																							theme: 'success',
																							position: 'top-stretch'
																						});
																						addEditWin.close();
																						detailWin.close();
																						actionManageDetails(taxHeader);
																						
																					}
																				});

																			}
																		}
																	},
																	{
																		theme: 'tertiary',
																		innerHTML: 'Cancel',
																		style: 'margin-left: 10px;',
																		listeners: {
																			click: function () {
																				//cancel
																				addEditWin.close();
																			}
																		}
																	}
																]
															}
														]
													}
												]
											});

											addEditWin.addToContentElement(formPanel);

											if (record) {
												var loadModel = {
													countryCode: record.countryCode,
													stateProvCode: record.stateProvCode,
													estimated: record.estimated,
													periodEndDate: record.periodEndDate,
													periodStartDate: record.periodStartDate,
													taxMonth: record.taxMonth,
													taxYear: record.taxYear													
												};
												record.rates.forEach(function(rate){
													loadModel[rate.fuelType + '.usTaxRate'] = rate.usRate;
													loadModel[rate.fuelType + '.usSurchargeRate'] = rate.usSurchargeRate;
													loadModel[rate.fuelType + '.canTaxRate'] = rate.canRate;
													loadModel[rate.fuelType + '.canSurchargeRate'] = rate.canSurchargeRate;
												});
												
												formPanel.load(loadModel);

											}
										});
										
									}
								}
							});							
							
						};
						
						var actionDeleteDetail = function(record) {
							
							window.DL.MessageUtil.showConfirm({
								title: 'Confirm Delete',
								message: 'Are you sure you want to delete the selected detail?',
								buttons: [
									{
										text: 'Yes',
										handler: function() {
											var loadMask = grid.showLoading('Removing...');

											var requestModel = {
												stateProvCode: record.stateProvCode,
												countryCode: record.countryCode,
												periodStartDate: record.periodStartDate,
												periodEndDate: record.periodEndDate
											};

											FueltaxService.getIftaService().deleteIftaDetails(taxHeader.iftaTaxId, requestModel)
											.then(function(){
												loadMask.remove();
												window.DL.MessageUtil.showToast('Success', 'Removed', {									
													theme: 'success'
												});
												actionDetailRefresh();
											});						
										}
									},
									{
										text: 'No'
									}
								]
							});
							
						};
						
						var actionExport = function() {
							FueltaxService.getIftaService().exportIftaTaxDetails(taxHeader.iftaTaxId);	
						};
					
					}
				}
			});	
		};
		
	}
	
}
customElements.define('dl-iftarates-grid', IftaRatesGrid);
